
import React, { FormEvent, useRef } from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Send, Loader2 } from "lucide-react";

interface ChatInputAreaProps {
  input: string;
  setInput: (value: string) => void;
  handleSubmit: (e: FormEvent) => void;
  isSubmitting: boolean; // Changed from MutableRefObject<boolean> to boolean
  isGenerating?: boolean;
  emailConcept?: string | null;
  companyInfo?: any;
  setShowCompanySettings?: (show: boolean) => void;
  textareaRef?: React.RefObject<HTMLTextAreaElement>;
  isStreaming?: boolean;
  placeholder?: string;
  onTemplateGenerationRequested?: (concept: string) => Promise<void>;
}

const ChatInputArea: React.FC<ChatInputAreaProps> = ({
  input,
  setInput,
  handleSubmit,
  isSubmitting,
  isGenerating = false,
  emailConcept,
  companyInfo,
  setShowCompanySettings,
  textareaRef,
  isStreaming = false,
  placeholder = "Schreiben Sie Ihre Nachricht...",
  onTemplateGenerationRequested
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e as unknown as FormEvent);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex items-center gap-2 p-4 border-t border-gray-800">
      <Input
        ref={inputRef}
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        className="flex-1 bg-gray-900 border-gray-800 text-white"
        disabled={isSubmitting || isGenerating} // Changed from isSubmitting.current to just isSubmitting
        data-testid="chat-input"
      />
      <Button 
        type="submit"
        size="icon"
        disabled={isSubmitting || isGenerating || !input.trim()} // Changed from isSubmitting.current to just isSubmitting
        className="bg-jade hover:bg-jade/90"
        data-testid="send-button"
      >
        {isSubmitting || isGenerating ? ( // Changed from isSubmitting.current to just isSubmitting
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <Send className="h-4 w-4" />
        )}
      </Button>
    </form>
  );
};

export default ChatInputArea;
